// `public class CityLicenseModel
//     {
//         public int link_no { get; set; }
//         public string cert_name { get; set; }
//         public decimal cert_cost { get; set; }
//     }` 

export class CityLicenseModel {
    link_no: number
    cert_name: string
    cert_cost: number

    constructor(
        link_no: number,
        cert_name: string,
        cert_cost: number
    ) {
        this.link_no = link_no
        this.cert_name = cert_name
        this.cert_cost = cert_cost
    }
}